export const FORM_ID = "dashboard-variables-drawer";
